<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb :crumbs="[{ 'path': 'roles', 'name': 'Roles'}, { 'name': `${role.identifier}`}]"/>
    <a-tabs defaultActiveKey="1" :size="size">
      <a-tab-pane tab="General" key="1">
        <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
          <a-form :layout="formLayout" :form="form" style="margin-top:1em;">
            <a-role-permission-field
              varName="identifier"
              varLabel="Identifier"
              :varRequired="true"
              :varInitial="role.identifier"
              :formLayout="formLayout"
              :size="size"
              :disabled="true"
            />
            <a-text-area-field
              varName="description"
              varLabel="Description"
              :varRequired="true"
              :varInitial="role.description"
              :formLayout="formLayout"
              :size="size"
              description="User friendly description which can be displayed on consent screen."
            />
            <a-form-item
              :wrapper-col="buttonItemLayout.wrapperCol"
              style="margin-top:0.5em;padding-left:4em;"
            >
              <a-button type="primary" shape="round" size="large" @click="handleSubmit">Update Details</a-button>
              <a-popconfirm
                v-if="!loading"
                placement="left"
                okText="Yes"
                cancelText="No"
                style="margin-left: 30px; float: right;"
                @confirm="handleDelete"
              >
                <p slot="title" style="font-size:14px;">Do you want to delete this role？</p>
                <a-icon slot="icon" type="question-circle-o" style="color: red" />
                <a-button type="danger" size="large">Delete role</a-button>
              </a-popconfirm>
            </a-form-item>
          </a-form>
        </a-skeleton>
      </a-tab-pane>
      <a-tab-pane tab="Permissions" key="2">
        <a-scope-transfer-field varLabel="Select Permissions" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";
import AScopeTransferField from "@/components/Form/AScopeTransferField";

export default {
  data() {
    return {
      loading: true,
      size: "large",
      formLayout: "horizontal",
      form: this.$form.createForm(this)
    };
  },
  methods: {
    async handleDelete() {
      try {
        await this.$store.dispatch("tenant/deleteItem", {
          endpoint: "roles",
          uuid: this.$route.params.uuid
        });
        await this.$router.push("/roles");
        await this.$notification.open({
          message: "Role delete!",
          description: "Role was deleted.",
          icon: (
            <a-icon type="check-circle" theme="filled" style="color: green" />
          )
        });
      } catch (error) {
        console.error(error);
      }
    },
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            await this.$store.dispatch("tenant/patchItem", {
              endpoint: "roles",
              uuid: this.$route.params.uuid,
              data: values
            });
            await this.$notification.open({
                message: 'Updated!',
                description: 'Role settings updated',
                icon: <a-icon type="check-circle" theme="filled" style="color: green" />
            });
          } catch (error) {
            console.error(error);
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    }
  },

  mixins: [formLayoutMixin],

  components: {
    AScopeTransferField,
  },
  computed: {
    role() {
      return this.$store.state.tenant.roles_item ? this.$store.state.tenant.roles_item : {};
    }
  },

  beforeCreate: async function() {
    this.form = this.$form.createForm(this);
    try {
      await this.$store.dispatch("tenant/getItem", {
        endpoint: "roles",
        uuid: this.$route.params.uuid
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>